import AiAgentManual from '../../../../components/units/Management/AiAgent/Manual/List';

export default function AiAgentManualPage() {
  return <AiAgentManual />;
}
